module.exports = __webpack_public_path__ + "static/media/1 0 Orddiktat Intro.8e4492c0.mp3";